import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import Validate from '../../../../../components/Validation/Validate';
import { required } from '../../../../../utils/validation/validator';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import CurrencySelector from '../../../components/CurrencySelector';

export class ExpenseClaimedItem extends React.Component {

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };

  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const {
      item,
      removable,
      disabled,
      validatorGroup,
      validationCounter,
      expenseType,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {
            (removable && !disabled) &&
            <div className="col-auto">
              <Button onClick={this.onRemoveClick}>
                Remove
              </Button>
            </div>
          }
          <div className="col-auto">
            <PageSectionHeader>
              {(expenseType === 1 || expenseType === 4) &&
              <FormattedMessage {...messages.expensesClaimedTitle} values={{ index: this.props.index + 1 }} />}
              {expenseType === 2 &&
              <FormattedMessage {...messages.golfExpense} values={{ index: this.props.index + 1 }} />}
              {expenseType === 3 &&
              <FormattedMessage {...messages.bicycleExpense} values={{ index: this.props.index + 1 }} />}
            </PageSectionHeader>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.dateOfExpense}
              fieldName={messages.dateOfExpense}
            >
              <DatePicker
                position={'top-start'}
                disabled={disabled}
                name="dateOfExpense"
                type="text"
                onDayChange={this.handleDayChange('dateOfExpense')}
                value={item.dateOfExpense}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.dateOfExpense} />
              </ErrorMessage>
            </Validate>

          </div>

          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.description}
              fieldName={messages.description}
            >
              <Textbox
                disabled={disabled}
                name="description"
                type="text"
                onChange={this.onChange('description')}
                value={item.description}
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.description} />
              </ErrorMessage>
            </Validate>

          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amount}
              fieldName={messages.amountClaimed}
            >
              <Textbox
                disabled={disabled}
                name="treatmentReceived"
                type="number"
                onChange={this.onChange('amount')}
                value={item.amount}
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.amountClaimed} />
              </ErrorMessage>
            </Validate>

          </div>
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currency')}
                disabled={disabled}
                value={item.currency}
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.currency} />
              </ErrorMessage>
            </Validate>

          </div>
        </div>

      </div>
    );
  }
}

ExpenseClaimedItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  expenseType: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/components/ExpensesClaimed/ExpenseClaimedItem.js